import React, { useEffect, useState } from "react";

const DrawLine = ({ points = [], containerRef }) => {
  const [lineStyle, setLineStyle] = useState(null);

  useEffect(() => {
    if (!containerRef?.current || points.length < 2) return;

    const rect = containerRef.current.getBoundingClientRect();

    const x1 = points[0].x;
    const y1 = points[0].y;
    const x2 = points[1].x;
    const y2 = points[1].y;

    const pxX1 = (x1 / 100) * rect.width;
    const pxY1 = (y1 / 100) * rect.height;
    const pxX2 = (x2 / 100) * rect.width;
    const pxY2 = (y2 / 100) * rect.height;

    const lengthPx = Math.sqrt((pxX2 - pxX1) ** 2 + (pxY2 - pxY1) ** 2);

    const lengthPercentage = (lengthPx / rect.width) * 100;

    const angle = Math.atan2(pxY2 - pxY1, pxX2 - pxX1) * (180 / Math.PI);

    setLineStyle({
      position: "absolute",
      top: `${y1}%`,
      left: `${x1}%`,
      width: `${lengthPercentage}%`,
      height: "0.5%",
      backgroundColor: "#fff",
      transform: `rotate(${angle}deg)`,
      transformOrigin: "0 0",
      zIndex: "1",
    });
  }, [points, containerRef]);

  if (!lineStyle) return null;

  return <div className="line" style={lineStyle} />;
};

export default DrawLine;
